import { Rubles } from 'Cloud/Application/Rubles';
import React, { useCallback } from 'react';
import { DOM_ID_INSIDE_PHONE_DATALIST } from 'reactApp/appHelpers/advertisingConfigHelpers';
import { ADS_TIMER_MS } from 'reactApp/constants';
import { useShowAdsBannerTimer } from 'reactApp/hooks/useShowAdsBannerTimer';
import { captureException } from 'reactApp/utils/tracer';

export const AdvBanner = () => {
    const updateAds = useCallback(() => {
        try {
            Rubles?.updateAdvPhonePublicInsideDatalist();
        } catch (error) {
            captureException(error, { issueKey: 'advBanner exception' });
        }
    }, []);

    return useShowAdsBannerTimer({
        adsUpdateTimerMs: ADS_TIMER_MS,
        updateAds,
        renderItem: () => <div id={DOM_ID_INSIDE_PHONE_DATALIST} />,
    });
};

AdvBanner.displayName = 'AdvBanner';
